var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSewerage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5861_78594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 23.498C1.56444 23.5989 2.39113 23.5166 3.16968 23.2571C3.94822 22.9976 4.65897 22.5674 5.25 21.998C5.67657 22.4698 6.19733 22.847 6.77865 23.1051C7.35998 23.3632 7.98895 23.4965 8.625 23.4965C9.26105 23.4965 9.89002 23.3632 10.4713 23.1051C11.0527 22.847 11.5734 22.4698 12 21.998C12.4266 22.4698 12.9473 22.847 13.5287 23.1051C14.11 23.3632 14.739 23.4965 15.375 23.4965C16.011 23.4965 16.64 23.3632 17.2213 23.1051C17.8027 22.847 18.3234 22.4698 18.75 21.998C19.341 22.5674 20.0518 22.9976 20.8303 23.2571C21.6089 23.5166 22.4356 23.5989 23.25 23.498",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.748H0.75",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.24805H7.5",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.74805H11C11 4.74805 12 4.74805 12 5.74805V14.248C12 14.248 12 15.248 11 15.248H8.5C8.5 15.248 7.5 15.248 7.5 14.248V5.74805C7.5 5.74805 7.5 4.74805 8.5 4.74805Z",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18 14.3861C14.1741 13.9613 13.0919 13.7469 12 13.7561",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.2969C18.7123 17.0417 19.2787 17.9134 19.67 18.8669",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 8.8457C16.0692 9.07941 17.0596 9.4353 17.9969 9.9057",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8047 11.7754C21.5937 12.452 22.2988 13.2208 22.9047 14.0654",
    stroke: "#9B90A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5861_78594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9998,
    height: 23.9998,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewerage);
export default __webpack_public_path__ + "static/media/sewerage.2acc8a06e33cc438a25b3525dfa11219.svg";
export { ForwardRef as ReactComponent };